import { render, staticRenderFns } from "./SalesManagerSubAgents.vue?vue&type=template&id=81d086da&scoped=true&"
import script from "./SalesManagerSubAgents.vue?vue&type=script&lang=js&"
export * from "./SalesManagerSubAgents.vue?vue&type=script&lang=js&"
import style0 from "./SalesManagerSubAgents.vue?vue&type=style&index=0&id=81d086da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81d086da",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VChip,VDataTable,VDialog,VDivider,VIcon,VTextField})
